module.exports = __webpack_public_path__ + "img/make-money.03e52d3a.svg";